import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks";

import type { DEALER_DOCUMENTATION_CATEGORIES, DealerDocumentation } from "models";

const component = "DealersDocumentations";

export type DealerDocumentationsFilters = {
  dealer_ids: number[];
  category_id?: DEALER_DOCUMENTATION_CATEGORIES;
  visible_to_mechanic: boolean;
  dealer_location_ids: number[];
};

export const DealerDocumentationsQueryKeys = {
  filters: localQueryKey<DealerDocumentationsFilters>({ component, data: "filters" }),
  list: backendQueryKey<DealerDocumentation[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/documentations/list" })
};
